module.exports = __webpack_public_path__ + "img/109.6.e9c0ef12.png";